<template>
  <aside class="sidebar" v-show="!hideSidebar">
    <div class="sidebar__brand">
      <div class="logo">
        EliteFit.AI
        <span class="logo__green">admin</span>
      </div>
    </div>
    <div
      class="d-flex flex-column flex-fill justify-content-center align-items-center"
    >
      <div class="profile-pic d-flex justify-content-center align-items-center">
        <div class="userImage">
          <img
            v-if="trainerData.profilePicUrl"
            :src="trainerData.profilePicUrl"
            alt="profile-pic"
            @error="setAltImg"
            class="img-fluid image"
          />
          <img
            v-else
            :src="require('../../../assets/user.png')"
            class="img-fluid image"
          />
        </div>
      </div>
      <div class="user-name mb-3">{{ trainerData.name }}</div>
    </div>
    <div class="sidebar__nav">
      <b-nav vertical>
        <b-nav-item
          active-class="sidebar__nav-link--active"
          link-classes="sidebar__nav-link"
          v-for="item in navItems"
          :key="item.title"
          :to="item.to"
        >
          <i :class="'icon' + ' ' + 'icon-' + item.icon"></i>
          {{ item.title }}
          <b-nav vertical v-if="item.submenu" class="mt-1">
            <b-nav-item
              active-class="sidebar__nav-link--active"
              link-classes="sidebar__nav-link ml-2"
              v-for="i in item.submenu"
              :key="i.title"
              :to="i.redirect_to"
            >
              {{ i.title }}
            </b-nav-item>
          </b-nav>
        </b-nav-item>
      </b-nav>
    </div>
  </aside>
</template>

<script>
import profileImg from "../../../assets/user.png";
import { createNamespacedHelpers } from "vuex";
const {
  mapActions: trainerProfile,
  mapGetters: trainerProfileGetter,
} = createNamespacedHelpers("admin/trainerProfileEdit");
const { mapGetters, mapActions, mapMutations } = createNamespacedHelpers(
  "admin/defaultView"
);

export default {
  data: function () {
    return {
      navItems: null,
    };
  },
  computed: {
    ...mapGetters(["hideSidebar"]),
    ...trainerProfileGetter(["trainerProfileData"]),
    userName() {
      let name = this.$store.state.userInfo.name;
      if (name.trim().length) {
        return name;
      } else {
        let email = this.$store.state.userInfo.email;
        return email.split("@")[0];
      }
    },
    trainerData() {
      if (this.trainerProfileData) {
        let data = {
          name: this.trainerProfileData.Name,
          profilePicUrl: this.trainerProfileData.profilePicUrl,
        };
        return data;
      }
    },
  },

  methods: {
    ...trainerProfile(["loadTrainerProfile"]),

    setAltImg() {
      this.trainerData.profilePicUrl = profileImg;
    },
  },
  mounted() {
    this.navItems = JSON.parse(localStorage.getItem("menuItems"));
    this.navItems.push({
      icon: "search",
      id: 999,
      submenu: null,
      title: "Text Search",
      to: "/admin/text-search"
    })
  },
  async created() {
    await this.loadTrainerProfile();
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "setSelectedTenant") {
        this.loadTrainerProfile();
      }
    });
  },

  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>

<style scoped>
.profile-pic {
  position: absolute;
  top: 60px;
}

.userImage {
  width: 110px;
  object-fit: cover;
  height: 135px;
  border-radius: 50%;
}

.user-name {
  position: absolute;
  top: 210px;
  font-size: 18px;
  color: #fff !important;
  font-family: Kanit-Regular;
}

.sidebar {
  display: grid;
  grid-template-columns: minmax(0px, 1fr);
  grid-template-rows: 50px minmax(0px, 1fr);
  background-color: #1c1c1c;
  color: #ffffff !important;
}

.sidebar__brand {
  background-color: black;
  display: flex;
  align-items: center;
  padding: 0 20px;
  display: none;
}
.logo {
  font-size: 19px;
  font-weight: 600;
  letter-spacing: 0.2px;
}
.logo__green {
  font-weight: 400;
  color: #28c76f !important;
}
.sidebar__nav {
  font-size: 0.8rem;
  padding: 8px 0 0;
  /* margin-top: 40px; */
  margin-top: 210px;
}

.sidebar__nav-link {
  color: #bcbec0 !important;
  padding: 0.5rem 1.2rem;
  font-size: 18px;
  font-family: Kanit-Regular;
}
.icon {
  font-size: 14px;
  padding-right: 8px;
}

.sidebar__nav-link:hover {
  color: #28c76f !important;
}
.sidebar__nav-link--active,
.sidebar__nav-link--active:hover {
  color: #28c76f !important;
}
.image {
  height: 100%;
  width: 100%;
  border-radius: 50%;
}
</style>